import moment from "moment";
import { DaysOfWeek } from "src/latest/src/constants/DateTime";

export function getTimeAsPerBlackoutHours(
    startDateTime: Date,
    blackoutHours: string,
    blackoutDays: string,
    practiceTimeZone: string
) {
    const endDateTime = startDateTime; // Clone the start date

    let remainingBlackoutHours = parseInt(blackoutHours);

    if (remainingBlackoutHours) {
        while (remainingBlackoutHours > 0) {
            // Move the time forward by 1 hour
            endDateTime.setHours(endDateTime.getHours() + 1);

            // Get the day of the week (0 for Sunday, 6 for Saturday)
            const dayOfWeek = endDateTime.getDay();
            const dayName = DaysOfWeek[dayOfWeek];

            // If the current day is a blackout day, skip it
            if (blackoutDays.includes(dayName)) {
                continue;
            }

            // Decrement blackout time for each valid hour
            remainingBlackoutHours--;
        }
    }

    const dateTime = practiceTimeZone
        ? moment(endDateTime?.toISOString()).tz(practiceTimeZone)
        : moment(endDateTime?.toISOString());

    return dateTime.format("YYYY-MM-DDTHH:mm:ss.SSSZ");
}
